export default "__VITE_ASSET__Bx_osR10__"